export default __webpack_public_path__ + "static/media/green-shadow.1f501bd4.png";